import BackLayout from './BackLayout';

export default BackLayout;



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/BackLayout/index.ts